import { render } from "./FormReg.vue?vue&type=template&id=f15ba976&scoped=true"
import script from "./FormReg.vue?vue&type=script&lang=js"
export * from "./FormReg.vue?vue&type=script&lang=js"

import "./FormReg.vue?vue&type=style&index=0&id=f15ba976&scoped=true&lang=css"

import exportComponent from "D:\\Development\\javascript\\accounts-butago-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f15ba976"]])

export default __exports__